import * as yup from 'yup';
export const firstStepSchema = yup.object({
  FirstName: yup.string().required('First name is required'),
  LastName: yup.string().required('Last name is required'),
  Email: yup
    .string()
    .test('is-valid-email', 'Invalid email address', (value) => {
      if (!value) return false;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(value);
    })
    .required('Email address is required'),
  ContactAddress: yup.string().required('Contact address is required'),
  City: yup.string().required('City is required'),
  State: yup.string().required('State is required'),
  Country: yup.string().required('Country is required'),
  PhoneNumber: yup
    .string()
    .matches(/^[0-9]{13}$/, 'Phone number must be 13 digits including 234')
    .required('Phone number is required'),
});

export const step2ValidationSchema = yup.object({
  RentPrice: yup.string().required('Rent price are required'),
  RequestedAmount: yup.string().required('Requested amount is required'),
  LandlordName: yup.string().required('Landlord name is required'),
  houseType: yup.string().required('House type is required'),
  LandlordAccountName: yup
    .string()
    .required('Landlord account name is required'),
  LandlordAccountNumber: yup
    .string()
    .required('Landlord account number is required'),
  LandlordBankName: yup.string().required('Landlord bank name is required'),
  LandlordContactNumber: yup
    .string()
    .required('Landlord contact number is required'),
});

export const step3ValidationSchema = yup.object({
  Occupation: yup.string().required('Occupation is required'),
  CompanyName: yup.string().required('Company name is required'),

  YearsOfWork: yup.string().required('Years of work is required'),
  CompanyEmail: yup.string().required('Company email is required'),
  CompanyPhoneNumber: yup.string().required('Company phone number is required'),
  CompanyLocation: yup.string().required('Company location is required'),
});

export const step4ValidationSchema = yup.object({
  UtilityBill: yup
    .mixed()
    .required('Utility bill is required')
    .test(
      'fileSize',
      'File size is too large. Maximum size is 5MB.',
      (file: any) => {
        return file ? file.size <= 5 * 1024 * 1024 : true;
      }
    ),
  IDCard: yup
    .mixed()
    .required('IDCard is required')
    .test(
      'fileSize',
      'File size is too large. Maximum size is 5MB.',
      (file: any) => {
        return file ? file.size <= 5 * 1024 * 1024 : true;
      }
    ),
  BankStatement: yup
    .mixed()
    .required('Bank statement is required')
    .test(
      'fileSize',
      'File size is too large. Maximum size is 5MB.',
      (file: any) => {
        return file ? file.size <= 5 * 1024 * 1024 : true;
      }
    ),
});
export interface Step1Type {
  FirstName: string;
  LastName: string;
  Email: string;
  ContactAddress: string;
  City: string;
  State: string;
  PostalCode: string;
  Country: string;
  PhoneNumber: string;
}
export interface Step2Types {
  RentPrice: string;
  RequestedAmount: string;
  LandlordName: string;
  LandlordEmail: string;
  houseType: string;
  LandlordAccountName: string;
  LandlordAccountNumber: string;
  LandlordBankName: string;
  LandlordContactNumber: string;
}
export interface Step3Types {
  Occupation: string;
  CompanyName: string;
  YearsOfWork: string;
  CompanyEmail: string;
  CompanyPhoneNumber: string;
  CompanyLocation: string;
}
export interface Step4Types {
  UtilityBill: File | null;
  IDCard: File | null;
  BankStatement: File | null;
  BankStatement2: File | null;
  BankStatement3: File | null;
  TenancyAgreement: File | null;
  PaySlip: File | null;
  TermsCondition: boolean;
}

export interface Step1Props {
  handleInputDataUpdate: (data: any) => void;
  nextStep: () => void;
}
export interface Step2Props {
  handleInputDataUpdate: (data: any) => void;
  prevStep: () => void;
  nextStep: () => void;
}

export const houseTypes = [
  { label: 'Self Contain (Selfcon)', value: 'selfcon' },
  { label: 'Single Room (Shared Facilities)', value: 'single_room' },
  { label: 'Mini Flat (1 Bedroom + Living Room)', value: 'mini_flat' },
  { label: '2 Bedroom Flat', value: '2_bedroom' },
  { label: '3 Bedroom Flat', value: '3_bedroom' },
  { label: 'Bungalow', value: 'bungalow' },
  { label: 'Duplex', value: 'duplex' },
  { label: 'Terrace', value: 'terrace' },
  { label: 'Penthouse', value: 'penthouse' },
  { label: 'Studio Apartment', value: 'studio' },
  { label: 'Mansion', value: 'mansion' },
  { label: 'Others', value: 'others' },
];
